import { ActionIcon, Tooltip } from '@mantine/core'
import { useFullscreenDocument } from '@mantine/hooks'
import { IconMaximize, IconMinimize } from '@tabler/icons-react'
import { type ReactNode, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import mark from '../../../art/brand/thananan-icon-orange.svg?url'
import classes from './screen.module.css'

/** The time now, moving on at each minute */
export function useNow() {
  const [now, setNow] = useState(() => new Date())
  useEffect(() => {
    let timer = 0
    const next = () => {
      setNow(new Date())
      timer = window.setTimeout(next, 60_000 - (Date.now() % 60_000) + 20)
    }
    timer = window.setTimeout(next, 60_000 - (Date.now() % 60_000) + 20)
    return () => window.clearTimeout(timer)
  }, [])
  return now
}

/**
 * Every look in one frame: the company's mark and name at the top with the fullscreen button, the look in the middle,
 * and what only its person (or its branch) needs at the bottom. Calm (the app's container tone) while it pairs, waits,
 * thanks or shows the time clock's QR, the canvas under a sheet to sign on
 */
export function Frame({
  company,
  calm,
  asking,
  foot,
  children,
}: {
  company?: string
  calm?: boolean
  asking?: boolean
  foot?: ReactNode
  children: ReactNode
}) {
  const { t } = useTranslation()
  const { toggle, fullscreen } = useFullscreenDocument()
  const label = t(fullscreen ? 'screen.exitFullscreen' : 'screen.fullscreen')
  return (
    <div className={classes.page} data-calm={calm || undefined} data-asking={asking || undefined}>
      <header className={classes.bar}>
        <div className={classes.brand}>
          <img src={mark} alt="" width={36} height={36} />
          {company && <span>{company}</span>}
        </div>
        <Tooltip label={label}>
          <ActionIcon variant="subtle" color="gray" size={44} radius="xl" className={classes.corner} onClick={toggle} aria-label={label}>
            {fullscreen ? <IconMinimize size={22} stroke={1.75} /> : <IconMaximize size={22} stroke={1.75} />}
          </ActionIcon>
        </Tooltip>
      </header>
      <main className={classes.main}>{children}</main>
      {foot && <footer className={classes.foot}>{foot}</footer>}
    </div>
  )
}
